import { DateTime } from 'luxon'

// A contract end and a paid period's end are stored as the first instant not
// served, 00:00 German time after the last day, and named by that last day.
// A Stripe period end later in a day keeps its own date.
export function lastDay(end: DateTime): DateTime {
  return end.setZone('Europe/Berlin').minus({ seconds: 1 })
}

// The German day before the one end falls on, whatever its time of day, as
// the backend's prepaid.LastDay names the last day of a monthly period, which
// ends at the time of day its subscription started.
export function dayBefore(end: DateTime): DateTime {
  return end.setZone('Europe/Berlin').startOf('day').minus({ days: 1 })
}

export function lastDayShort(unixSeconds: number): string {
  return lastDay(DateTime.fromSeconds(unixSeconds)).toLocaleString(DateTime.DATE_SHORT)
}

// The contract end of a cancellation received at now under AGB § 3.2: with the
// day one calendar month later, German time, or the last day of a shorter
// month, as the backend's prepaid.TermEnd.
export function termEnd(now: DateTime = DateTime.now()): DateTime {
  return now.setZone('Europe/Berlin').startOf('day').plus({ months: 1 }).plus({ days: 1 })
}
